import React, { Dispatch, SetStateAction, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

import stylesModule from '../../styles/stylesInicio.module.css';
import { Pagination } from 'swiper';
import { Card, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';


interface Props {
  arrMateriales: any;
  openPDF: boolean;
  setModalMaterialCopy: Dispatch<SetStateAction<string>>;
  setModalMaterialesAdvice: Dispatch<SetStateAction<boolean>>;
  setCurrentItemModal: Dispatch<SetStateAction<'rutinas' | 'alimentacion'>>;
  setLinkPdfAlimentacion: Dispatch<SetStateAction<string>>;
  seconds: number;
}

const SwiperResultadosPC = ({arrMateriales, openPDF, seconds, setCurrentItemModal, setLinkPdfAlimentacion, setModalMaterialCopy, setModalMaterialesAdvice } : Props) => {

  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  
  const matches = useMediaQuery('(max-width: 1025px)');
  const matches2 = useMediaQuery('(max-width: 1250px)');
  const navigate = useNavigate();

  const goNext = () => {
    if (swiperInstance && swiperInstance.slideNext) {
      swiperInstance.slideNext();
    }
  };
  
  const goPrev = () => {
    if (swiperInstance && swiperInstance.slidePrev) {
      swiperInstance.slidePrev();
    }
  };

  function handleOpenMaterial(
    copy: string,
    linkdf: string,
    url?: string,
    pdfBono?: boolean,
  ) {
    if (url === '/misRutinas' && seconds > 0) {
      setModalMaterialCopy(copy);
      setModalMaterialesAdvice(true);
      setCurrentItemModal('rutinas');
      return;
    }
    if (url === '/planAlimentacion' && seconds > 0) {
      setModalMaterialCopy(copy);
      setModalMaterialesAdvice(true);
      setCurrentItemModal("alimentacion");
      return;
    }

    if (pdfBono) {
      window.open(linkdf, '_blank'); // abre la URL en una nueva pestaña
      return;
    }

    if (linkdf) {
      if (seconds > 0) {
        setModalMaterialCopy(copy);
        setModalMaterialesAdvice(true);
        setCurrentItemModal('alimentacion');
        setLinkPdfAlimentacion(linkdf);
      } else {
        window.open(linkdf, '_blank'); // abre la URL en una nueva pestaña
      }
    } else {
      if (url) {
        switch (url) {
          case '/misRutinas':
            navigate('/misRutinas');
            window.scrollTo(0, 0);
            localStorage.setItem('habilitarRutinas', String(true));
            break;
          case '/podcasts':
            navigate('/podcasts');
            window.scrollTo(0, 0);
            break;
          case '/preguntasFrecuentes':
            navigate('/preguntasFrecuentes');
            window.scrollTo(0, 0);
            break;
          case '/planAlimentacion':
            navigate('/planAlimentacion');
            window.scrollTo(0, 0);
            break
          case '/aceleradores':
            navigate('/aceleradores');
            window.scrollTo(0, 0);
            break
          case '/tuProgreso':
            navigate('/tuProgreso');
            window.scrollTo(0, 0);
          default:
            break;
        }
      }
    }
  }

  return (
    <>
      <div className="relative">
        <Swiper
          slidesPerView={matches ? 2 : matches2 ? 3 : 4}
          spaceBetween={20}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper w-[80vw] m-auto"
          // style={{ width: '80vw', margin: 'auto' }}
          onSwiper={(swiper) => setSwiperInstance(swiper)}
        >
          {arrMateriales &&
            arrMateriales.length > 0 &&
            arrMateriales.map((material: any, index: number) => {
              if (material.title === 'Preguntas frecuentes') {
                return (
                  <SwiperSlide
                    style={{
                      marginBottom: '2rem',
                      display: openPDF ? 'none' : '',
                      boxShadow: 'none',
                    }}
                    key={index}
                  >
                    <Card
                      className="p-3"
                      sx={{
                        maxWidth: '350px',
                        margin: '2rem 0',
                        border: '0',
                        boxShadow: 'none',
                      }}
                    >
                      <div onDragStart={(e) => e.preventDefault()}>
                        <div
                          className="p-2 rounded-lg flex flex-col items-center min-h-[200px] justify-center cursor-pointer"
                          style={{
                            border: '1px solid #ff4646',
                            boxShadow: `
                              inset 0 4px 6px rgba(255, 255, 255, 0.3),
                              inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                              0 4px 10px rgba(0, 0, 0, 0.25)
                            `,
                            backgroundColor: 'red',
                            color: 'white',
                          }}
                          onClick={() => {
                            handleOpenMaterial(
                              material.copy,
                              material.pdfLink,
                              material.url,
                              material.pdfBono && true,
                            );
                          }}
                        >
                          <div>
                            <img
                              height={120}
                              width={120}
                              src={material.imgFromProject}
                              alt=""
                            />
                          </div>
                          <div>
                            <p className="text-center font-bold text-lg uppercase">
                              {material.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </SwiperSlide>
                );
              }
              if (material.title === 'Aceleradores') {
                return (
                  <SwiperSlide
                    style={{
                      marginBottom: '2rem',
                      display: openPDF ? 'none' : '',
                      boxShadow: 'none',
                    }}
                    key={index}
                  >
                    <Card
                      className="p-3"
                      sx={{
                        maxWidth: '350px',
                        margin: '2rem 0',
                        border: '0',
                        boxShadow: 'none',
                      }}
                    >
                      <div onDragStart={(e) => e.preventDefault()}>
                        <div
                          className="p-2 rounded-lg flex flex-col items-center justify-center min-h-[200px] bg-[#3aaa23] cursor-pointer"
                          style={{
                            border: '1px solid #50b63c',
                            boxShadow: `
                              inset 0 4px 6px rgba(255, 255, 255, 0.3),
                              inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                              0 4px 10px rgba(0, 0, 0, 0.25)
                            `,
                            color: 'white',
                          }}
                          onClick={() => {
                            handleOpenMaterial(
                              material.copy,
                              material.pdfLink,
                              material.url,
                              material.pdfBono && true,
                            );
                          }}
                        >
                          <div>
                            <img
                              height={120}
                              width={120}
                              src={material.imgFromProject}
                              alt=""
                            />
                          </div>
                          <div>
                            <p className="text-center font-bold text-lg uppercase">
                              {material.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </SwiperSlide>
                );
              }

              if (material.src.trim() !== '') {
                return (
                  <SwiperSlide
                    style={{
                      marginBottom: '2rem',
                      display: openPDF ? 'none' : '',
                      boxShadow: 'none',
                    }}
                    key={index}
                  >
                    <Card
                      className="p-3"
                      sx={{
                        maxWidth: '350px',
                        margin: '2rem 0',
                        border: '0',
                        boxShadow: 'none',
                      }}
                    >
                      <div onDragStart={(e) => e.preventDefault()}>
                        <div
                          className="p-2 rounded-lg flex flex-col bg-gray-200 items-center min-h-[200px] justify-center cursor-pointer"
                          style={{
                            border: 'none',
                            boxShadow: `
                              inset 0 4px 6px rgba(255, 255, 255, 0.3),
                              inset 0 -4px 6px rgba(0, 0, 0, 0.2),
                              0 4px 10px rgba(0, 0, 0, 0.25)
                            `,
                          }}
                          onClick={() => {
                            handleOpenMaterial(
                              material.copy,
                              material.pdfLink,
                              material.url,
                              material.pdfBono && true,
                            );
                          }}
                        >
                          <div>
                            <img
                              height={120}
                              width={120}
                              src={material.imgFromProject}
                              alt=""
                            />
                          </div>
                          <div>
                            <p className="text-center font-bold text-lg uppercase">
                              {material.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </SwiperSlide>
                );
              }
            })}
        </Swiper>

        {/* Flechas de navegación */}
        <div className={stylesModule.swiperButtonPrev} onClick={goPrev}></div>
        <div className={stylesModule.swiperButtonNext} onClick={goNext}></div>
      </div>
    </>
  )
}

export default SwiperResultadosPC